export const FooterNavigationLinks = {
  privacyPolicy: '/privacy/',
  termsAndConditions: '/terms-and-conditions/'
}
